<template>
  <div>
    <b-navbar
      class="px-5 py-0 nav_bar_flex bg-white"
      toggleable="lg"
      type="light"
      fixed="top"
    >
      <b-navbar-brand href="#">
        <p class="fs-18 t-red font-weight-bold mb-0">
          <img src="@/assets/img/main_logo.png" alt="" width="30" />
          Pre<span class="t-black font-weight-bold">Order.id</span>
        </p>
      </b-navbar-brand>
      <b-navbar-toggle
        v-b-toggle.sidebar-no-header
        target="nav-collapsessx"
      ></b-navbar-toggle>
      <!-- <b-button v-b-toggle.sidebar-1>Toggle Sidebar</b-button> -->
      <b-sidebar
        id="sidebar-no-header"
        aria-labelledby="sidebar-no-header-title"
        no-header
        shadow
      >
        <template v-slot:default="{ hide }">
          <div class="bg-white h-100">
            <div class="nav_bar_flex px-3">
              <span
                class="fs-18 text-dark font-weight-bold mr-4 pointer"
                @click="hide"
                >X</span
              ><span class="fs-18 text-dark font-weight-bold mb-0">Menu</span>
            </div>
            <div class="content_menu_list px-3">
              <li v-for="(item, id) in icon_nav" :key="id">
                <img
                  :src="item.src"
                  alt=""
                  width="30"
                  class="align-middle mr-2"
                />
                <span class="align-middle">{{ item.name }}</span>
              </li>
              <router-link tag="li" :to="{ name: 'new-view' }"
                >Daftar/Masuk</router-link
              >
            </div>
          </div>
        </template>
      </b-sidebar>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            class="mx-4"
            :key="id"
            v-for="(n, id) in icon_nav"
            href="#"
            ><img :src="n.src" alt=""
          /></b-nav-item>
          <b-nav-item href="#"
            ><span class="t-black font-weight-bold">FAQ</span></b-nav-item
          >
          <b-nav-item href="#"
            ><span class="t-black font-weight-bold">BANTUAN</span></b-nav-item
          >
          <router-link
            ta="div"
            :to="{ name: 'new-view' }"
            class="b-red button_auth ml-3"
          >
            <img
              src="@/assets/img/people.png"
              alt=""
              width="30"
              class="rounded-circle"
            />
            <span class="fs-14 text-white ml-2">SIGNIN/LOGIN</span>
          </router-link>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      icon_nav: [
        { src: require("@/assets/img/red_car.png"), name: "Mobil" },
        { src: require("@/assets/img/home.png"), name: "Rumah" },
        { src: require("@/assets/img/head.png"), name: "Pendidikan" },
        { src: require("@/assets/img/truck.png"), name: "Truck" }
      ]
    };
  }
};
</script>
<style scoped>
.button_auth {
  height: 70px;
  padding: 10px;
  border-radius: 0 0 20px 20px;
}
.nav_bar_flex {
  height: 55px;
  line-height: 55px;
  box-shadow: 0 4px 20px rgba(149, 185, 193, 0.2);
}
.content_menu_list > li {
  list-style: none;
  font-weight: bold;
  border-bottom: 1px solid #d6d2d2;
}
</style>
